const THEME_KEY = "snx_theme_mode";

export function getStoredThemeMode() {
    const stored = localStorage.getItem(THEME_KEY);
    return stored === "light" ? "light" : "dark";
}

export function applyThemeMode(mode) {
    const normalized = mode === "light" ? "light" : "dark";

    localStorage.setItem(THEME_KEY, normalized);

    const html = document.documentElement;
    const body = document.body;

    html.setAttribute("data-theme", normalized);
    body.setAttribute("data-theme", normalized);

    html.classList.toggle("theme-light", normalized === "light");
    html.classList.toggle("theme-dark", normalized === "dark");

    body.classList.toggle("theme-light", normalized === "light");
    body.classList.toggle("theme-dark", normalized === "dark");

    // Extra stable admin selectors
    html.classList.toggle("snx-light-mode", normalized === "light");
    html.classList.toggle("snx-dark-mode", normalized === "dark");

    body.classList.toggle("snx-light-mode", normalized === "light");
    body.classList.toggle("snx-dark-mode", normalized === "dark");

    window.dispatchEvent(
        new CustomEvent("snx-theme-mode-changed", {
            detail: { mode: normalized }
        })
    );

    return normalized;
}

export function reapplyStoredThemeMode() {
    return applyThemeMode(getStoredThemeMode());
}

export function toggleThemeMode() {
    const current = getStoredThemeMode();
    return applyThemeMode(current === "dark" ? "light" : "dark");
}